import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AgentMarketingCampaign } from 'src/app/_shared/interface/campaign.interface';
import { CampaignService } from 'src/app/_shared/service/campaign.service';
import { CampaignState } from 'src/app/_shared/state/campaign.state';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import constants from 'src/constant.json';

@Component({
  selector: 'app-agent-marketing-campaigns',
  templateUrl: './agent-marketing-campaigns.component.html',
  styleUrls: ['./agent-marketing-campaigns.component.scss'],
})
export class AgentMarketingCampaignsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() isOpenCampaingInfo = new EventEmitter<boolean>();
  selection = new SelectionModel<any>(true, []);
  onDestroyNotifier$ = new Subject();
  tableDataSource: AgentMarketingCampaign[] = [];
  isOpenInfo = false;
  tableColumnList: string[] = ['campaignName', 'campaignType', 'candidateCount', 'emailOpenRate'];
  tableDefaultMarketingColumnList: string[] = ['campaignName', 'candidateCount', 'LeadCaptureRate', 'emailOpenRate',];
  DEFAULT_AUTOMATED_CAMP: any = constants.DEFAULT_AUTOMATED_CAMP;
  selectedInfo: any;
  pageIndex: number = 0;
  limit: number = 10;
  offset: number = 0;
  totalCount: number = 0;
  userType: any;
  userId: any;
  isLoanOfficer: boolean = false;
  isAgent: boolean = false;
  isCompanyManager: boolean = false;

  constructor(
    private campaignService: CampaignService,
    public campaignState: CampaignState,
    public appState: AppState,
    private userState: UserState,
  ) { }

  ngOnInit(): void {
    this.loadAutomatedCampaigns({ offset: 0, limit: 10 });
    this.campaignState.agentMarketingCampaignList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && res?.paginatedResults && res.paginatedResults.length > 0) {
        this.tableDataSource = res.paginatedResults || [];
        this.totalCount = res.totalRecords || 0;
      } else if (res) {
        let updatedResponse = [];
        this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((response) => {
          if (response) {
            this.userType = response?.userType || null;
            this.userId = response?.id || null;
            if (this.userType == 'loanOfficer') {
              this.isLoanOfficer = true;
            }
            if (this.userType == 'agent') {
              this.isAgent = true;
            }

            if (this.userType == 'companyManager') {
              this.isCompanyManager = true;
            }
          }
        });

        if (this.userType == 'loanOfficer' || this.userType == 'agent') {
          updatedResponse = this.getUserOnboardCountByOwnerId(res, this.userId, this.userType);
        } else if (this.userType == 'companyManager') {
          updatedResponse = res
        }

        this.tableDataSource = updatedResponse || [];
        this.totalCount = res.length || 0;
      } else {
        this.tableDataSource = [];
        this.totalCount = 0;
      }
    });
  }

  pageChange(event) {
    this.limit = event.pageSize;
    this.offset = event.pageSize * event.pageIndex;
    this.loadAutomatedCampaigns({ offset: this.offset, limit: this.limit });
  }

  loadAutomatedCampaigns(params) {
    this.pageIndex = params.offset ? params.offset / params.limit : 0;
    this.campaignService.fetchCampaignsForAgentMarketing(params);
  }

  openInfo(value) {
    this.selectedInfo = value;
    this.isOpenInfo = true;
  }

  changeBoolean(value: boolean) {
    this.isOpenCampaingInfo.emit(value);
  }

  onBack(event) {
    this.selectedInfo = null;
    this.campaignService.fetchCampaignsForAgentMarketing({ offset: this.offset, limit: this.limit });
    this.isOpenInfo = event;
    this.isOpenCampaingInfo.emit(false);
  }

  getLeadCaptureRate(element: any, role: 'agent' | 'companyManager' | 'loanOfficer'): number {

    if (!element) return 0;
    const data = element?.data?.[0];
    const candidateCount = (data?.candidateTotalCount ?? element?.data?.length);
    const leadCount =
      role === 'agent'
        ? data?.agentOnboardCountByOwner ?? 0
        : role === 'companyManager'
          ? data?.userOnboardCount ?? 0
          : role === 'loanOfficer'
            ? data?.loOnboardCountByOwner ?? 0
            : 0;

    if (!candidateCount || candidateCount <= 0) return 0;
    return (leadCount / candidateCount) * 100;
  }

  getUserOnboardCountByOwnerId(campaigns, ownerId, userType) {

    for (const campaign of campaigns) {
      for (const item of campaign.data) {
        let onboardCount = 0;
        if (userType == 'loanOfficer') {
          if (Array.isArray(item.loanOfficerOnboardCount)) {
            const match = item.loanOfficerOnboardCount.find(
              (entry) => entry.ownerId === ownerId
            );

            if (match) {
              onboardCount = match.userOnboardCount || 0;
            }
          }
          item.loOnboardCountByOwner = onboardCount;
        }
        if (userType == 'agent') {
          if (Array.isArray(item.agentOnboardCount)) {
            const match = item.agentOnboardCount.find(
              (entry) => entry.ownerId === ownerId
            );

            if (match) {
              onboardCount = match.userOnboardCount || 0;
            }
          }
          item.agentOnboardCountByOwner = onboardCount;
        }

      }

    }

    return campaigns;
  }




}
